import React from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import './CaseDetail.css';

const CaseDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  // 案例数据（与 CaseStudies.js 中的保持一致）
  const caseStudies = [
    {
      id: 1,
      title: "大型基建集团多项目协同管理",
      client: "某大型基建集团",
      industry: "市政工程",
      logo: "[客户Logo]",
      overview: "实现多项目成本穿透式管理，审批效率提升40%",
      challenge: "该集团同时管理20+个大型基建项目，面临成本数据滞后、合同管理分散、多项目协同困难等挑战，难以实现有效的项目监控和决策支持，导致项目延期风险高、成本超支频发。",
      solution: "通过部署星晟工程管控系统，实现了项目全周期透明化管理，打通了进度、成本、合同等关键环节，建立了统一的多项目协同管理平台，提供了实时的数据洞察和智能预警机制，让管理层能够实时掌握所有项目的运营状况。",
      results: [
        { label: "审批效率提升", value: "40%" },
        { label: "成本核算周期缩短", value: "50%" },
        { label: "合同履约风险降低", value: "30%" },
        { label: "项目延期率降低", value: "25%" }
      ],
      testimonial: "星晟的系统帮助我们第一次真正看清了所有项目的实时成本和进度，实现了从'拍脑袋决策'到'数据驱动决策'的转变，这是革命性的改变。现在我们可以提前发现风险，及时调整策略，项目成功率大幅提升。",
      author: "项目总监, 张先生",
      company: "某大型基建集团",
      implementation: [
        "部署了项目一体化管理模块，实现了20+项目的统一监控",
        "建立了多项目成本穿透式管理体系，实时掌握每个项目的资金流向",
        "上线了智能合同风控系统，自动预警合同履约风险",
        "实现了电子审批流程，大幅提升审批效率"
      ],
      keyFeatures: [
        "多项目协同管理平台",
        "实时成本监控与预警",
        "智能合同风控系统",
        "电子审批流程自动化"
      ]
    },
    {
      id: 2,
      title: "房地产开发商多项目资金管控",
      client: "知名房地产开发商",
      industry: "房地产",
      logo: "[客户Logo]",
      overview: "实现多项目资金统一管理，资金使用效率提升35%",
      challenge: "企业在同时开发15+个房地产项目时，资金使用效率低，难以实现统一的成本控制和资金调配，经常出现资金闲置或资金紧张的情况，影响项目进度和盈利能力。财务数据滞后，无法及时为决策提供支持。",
      solution: "引入星晟工程管控系统的成本资金看板功能，实现了对所有项目的实时资金监控和穿透式管理，建立了统一的资金池管理机制，支持多项目资金灵活调配，实现了从月度财务报告到实时财务监控的转变。",
      results: [
        { label: "资金使用效率提升", value: "35%" },
        { label: "项目利润率提高", value: "12%" },
        { label: "财务报告时效性", value: "从月度提升至实时" },
        { label: "资金成本降低", value: "18%" }
      ],
      testimonial: "星晟的解决方案让我们能够精准掌控每个项目的资金流向，实现了资金的优化配置，大大提升了我们的财务管理效率和盈利能力。现在我们可以实时了解每个项目的财务状况，及时调整资金策略，避免了资金浪费和项目风险。",
      author: "财务总监, 李女士",
      company: "知名房地产开发商",
      implementation: [
        "建立了统一的资金池管理平台，实现15+项目的资金统一调配",
        "部署了实时资金监控看板，实时掌握每个项目的资金状况",
        "实现了资金预算与执行的全程跟踪，提前预警资金风险",
        "打通了财务系统，实现了财务数据的实时同步"
      ],
      keyFeatures: [
        "统一资金池管理",
        "实时资金监控看板",
        "资金预算执行跟踪",
        "财务系统数据打通"
      ]
    },
    {
      id: 3,
      title: "市政工程项目全流程数字化管理",
      client: "某市政工程项目",
      industry: "市政工程",
      logo: "[客户Logo]",
      overview: "实现项目进度100%在线透明，跨部门协作效率提升45%",
      challenge: "市政工程项目涉及10+个部门和20+个承包商，进度信息不透明，协调困难，数据上报不及时，经常出现信息不对称导致的进度延误和质量问题，项目监管难度大。",
      solution: "采用星晟工程管控系统的项目一体化管理模块，实现了项目进度的全流程在线管理和实时监控，建立了统一的项目协同平台，所有参与方可以实时查看项目进度、提交数据、协同工作，实现了项目管理的数字化转型。",
      results: [
        { label: "项目进度透明度", value: "100%" },
        { label: "数据上报及时率", value: "98%" },
        { label: "跨部门协作效率", value: "提升45%" },
        { label: "项目延期率降低", value: "30%" }
      ],
      testimonial: "通过星晟的系统，我们实现了项目管理的数字化转型，各部门之间的协作变得更加高效顺畅。现在所有参与方都能实时了解项目进展，问题能够及时发现和解决，项目质量和进度都得到了显著提升。",
      author: "项目经理, 王先生",
      company: "某市政工程项目",
      implementation: [
        "建立了统一的项目协同平台，连接10+个部门和20+个承包商",
        "实现了项目进度的全流程在线管理，所有参与方可实时查看",
        "部署了数据上报系统，大幅提升数据上报及时率",
        "建立了项目质量监控机制，及时发现和解决问题"
      ],
      keyFeatures: [
        "统一项目协同平台",
        "全流程在线管理",
        "实时数据上报",
        "质量监控机制"
      ]
    }
  ];

  const caseStudy = caseStudies.find(c => c.id === parseInt(id));

  if (!caseStudy) {
    return (
      <div className="case-detail">
        <div className="container">
          <div className="not-found">
            <h1>案例未找到</h1>
            <p>抱歉，您访问的案例不存在。</p>
            <Link to="/case-studies" className="primary-button">返回案例列表</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="case-detail">
      {/* Hero Section */}
      <motion.section
        className="case-hero"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        <div className="container">
          <motion.div
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <Link to="/case-studies" className="back-link">
              ← 返回案例列表
            </Link>
          </motion.div>
          <motion.div
            className="case-header"
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            <div className="case-meta">
              <span className="eyebrow">{caseStudy.industry}</span>
              <span className="client-name">{caseStudy.client}</span>
            </div>
            <h1>{caseStudy.title}</h1>
            <p className="case-overview">{caseStudy.overview}</p>
          </motion.div>
        </div>
      </motion.section>

      {/* Challenge Section */}
      <motion.section
        className="case-challenge"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, margin: "0px 0px -100px 0px" }}
        transition={{ duration: 0.8 }}
      >
        <div className="container">
          <div className="section-content">
            <motion.h2
              initial={{ y: 20, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
            >
              面临的挑战
            </motion.h2>
            <motion.p
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.1 }}
            >
              {caseStudy.challenge}
            </motion.p>
          </div>
        </div>
      </motion.section>

      {/* Solution Section */}
      <motion.section
        className="case-solution"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, margin: "0px 0px -100px 0px" }}
        transition={{ duration: 0.8 }}
      >
        <div className="container">
          <div className="section-content">
            <motion.h2
              initial={{ y: 20, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
            >
              解决方案
            </motion.h2>
            <motion.p
              className="solution-intro"
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.1 }}
            >
              {caseStudy.solution}
            </motion.p>
            <motion.div
              className="key-features"
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <h3>核心功能</h3>
              <div className="features-grid">
                {caseStudy.keyFeatures.map((feature, index) => (
                  <motion.div
                    key={index}
                    className="feature-item"
                    initial={{ y: 20, opacity: 0 }}
                    whileInView={{ y: 0, opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5, delay: 0.3 + index * 0.1 }}
                  >
                    <div className="feature-icon">✓</div>
                    <span>{feature}</span>
                  </motion.div>
                ))}
              </div>
            </motion.div>
            <motion.div
              className="implementation"
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.4 }}
            >
              <h3>实施内容</h3>
              <ul className="implementation-list">
                {caseStudy.implementation.map((item, index) => (
                  <motion.li
                    key={index}
                    initial={{ y: 20, opacity: 0 }}
                    whileInView={{ y: 0, opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5, delay: 0.5 + index * 0.1 }}
                  >
                    {item}
                  </motion.li>
                ))}
              </ul>
            </motion.div>
          </div>
        </div>
      </motion.section>

      {/* Results Section */}
      <motion.section
        className="case-results"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, margin: "0px 0px -100px 0px" }}
        transition={{ duration: 0.8 }}
      >
        <div className="container">
          <div className="section-header">
            <motion.h2
              initial={{ y: 20, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
            >
              关键成果
            </motion.h2>
            <motion.p
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.1 }}
            >
              通过星晟工程管控系统的实施，客户取得了显著的业务成果
            </motion.p>
          </div>
          <div className="results-grid">
            {caseStudy.results.map((result, index) => (
              <motion.div
                key={index}
                className="result-card"
                initial={{ y: 30, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.1 * index }}
              >
                <div className="result-value">{result.value}</div>
                <div className="result-label">{result.label}</div>
              </motion.div>
            ))}
          </div>
        </div>
      </motion.section>

      {/* Testimonial Section */}
      <section className="case-testimonial">
        <div className="container">
          <div className="testimonial-content">
            <div className="quote-icon">"</div>
            <p className="testimonial-text">{caseStudy.testimonial}</p>
            <div className="testimonial-author">
              <span className="author-name">{caseStudy.author}</span>
              <span className="author-company">{caseStudy.company}</span>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="case-cta">
        <div className="container">
          <h2>想了解如何为您的企业带来同样的改变？</h2>
          <p>预约顾问演示，获得专属评估报告与落地路线图</p>
          <div className="cta-buttons">
            <Link to="/product" className="primary-button">预约产品演示</Link>
            <Link to="/contact" className="secondary-button">联系行业顾问</Link>
          </div>
        </div>
      </section>

      {/* Related Cases */}
      <section className="related-cases">
        <div className="container">
          <h2>更多成功案例</h2>
          <div className="related-grid">
            {caseStudies
              .filter(c => c.id !== caseStudy.id)
              .slice(0, 2)
              .map((relatedCase) => (
                <Link
                  key={relatedCase.id}
                  to={`/case-studies/${relatedCase.id}`}
                  className="related-card"
                >
                  <div className="related-meta">
                    <span>{relatedCase.client}</span>
                    <span>{relatedCase.industry}</span>
                  </div>
                  <h3>{relatedCase.title}</h3>
                  <p>{relatedCase.overview}</p>
                  <span className="read-more">查看详情 →</span>
                </Link>
              ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default CaseDetail;

